
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox.js';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox.js';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel.js';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';
// import { addingShowFilters } from './components/footer/farlo-ui-show-filter.js'

// Import Footer Components
import { cookieCompliance } from './components/footer/cookieCompliance.js';
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { navicon } from './components/footer/navicon.js';
import { navigation } from './components/footer/navigation.js';
import { smoothScroll } from './components/footer/smoothScroll.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { handleMenuHover } from './components/footer/nav-hover.js';
import { slideInColumns } from './components/footer/intersectionObserver.js';
import { dropdownFilter } from './components/footer/dropdownFilter.js';
import { farloUiSliderFade } from './components/footer/flickity-homepage-secondary.js';
import { farloUiMasthead } from './components/footer/flickity-masthead.js';
import { farloUiSlider } from './components/footer/flickity-gallery.js';
import { farloUiSliderMobile } from './components/footer/flickity-gallery-mobile.js';
import { farloUiContentSlider } from './components/footer/flickity-contentslider.js';
import { farloUiTimelineCarousel } from './components/footer/farlo-ui-timeline-carousel.js';
import { setTallestTimelineItemHeight } from './components/footer/setTallestTimelineHeight.js';
import { farloUiSliderReviews } from './components/footer/flickity-reviews.js';


((document, window, history) => {
	const pushState = history.pushState;


	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};


	document.addEventListener('DOMContentLoaded', () => {

		if (document.querySelector('.timeline')) {
			document.querySelectorAll('[farlo-ui="timeline"]').forEach((_sel) => {
				farloUiTimelineCarousel(_sel);
			});
			setTallestTimelineItemHeight();
		}

		if (document.querySelector('.content-slider__slider')) {
			document.querySelectorAll('.content-slider__slider').forEach((_sel) => {
				farloUiContentSlider(_sel);
			});
		}

		if (document.querySelector('.slider-wrapper')) {
			document.querySelectorAll('.slider-wrapper').forEach((_sel) => {
				farloUiSlider(_sel);
			});
		}

		if (document.querySelector('.revolver-carousel')) {
			document.querySelectorAll('.revolver-carousel').forEach((_sel) => {
				farloUiSliderReviews(_sel);
			});
		}

		if (document.querySelector('.is-style-mobile-slider')) {
			document.querySelectorAll('.is-style-mobile-slider').forEach((_sel) => {
				farloUiSliderMobile(_sel);
			});
		}

		if (document.querySelector('.masthead-slider')) {
			document.querySelectorAll('.masthead-slider').forEach((_sel) => {
				farloUiMasthead(_sel);
			});
		}

		if (document.querySelector('.slider-fade')) {
			document.querySelectorAll('.slider-fade').forEach((_sel) => {
				farloUiSliderFade(_sel);
			});
		}

		if (document.querySelector('.site-show-filter')) {
			dropdownFilter();
		}

		if (document.querySelector('.site-cast')) {
			const divs = document.querySelectorAll(".site-cast__member");

			divs.forEach((item) => {
				item.addEventListener("click", () => {
					divs.forEach((el) => el.classList.remove("active"));

					item.classList.add("active");
				});
			});
		}


		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-navigation__list, .site-footer__navigation-list')) {
			handleMenuHover();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {

			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}


		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelectorAll('.is-style-fade-in')) {
			slideInColumns();
		}

		// if (document.querySelector('.farlo-ui-crm__toggle')) {
		// 	document.querySelectorAll('.farlo-ui-crm__toggle').forEach((_sel) => {
		// 		_sel.addEventListener('click', (e) => {
		// 			e.preventDefault();
		// 			e.stopImmediatePropagation();
		// 			farloUiCrmSignup(e);
		// 		});
		// 	});
		// }

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function (button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function (block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll(".rank-math-question").forEach((_el) => {
				_el.dataset.toggled = "0";
				_el.addEventListener("click", () => {
					toggleFAQ(_el);
				})
			});
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}



		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});

		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}


		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function (buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}


	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
